import { render } from "./CarouselIndu.vue?vue&type=template&id=729b7761&scoped=true"
import script from "./CarouselIndu.vue?vue&type=script&lang=js"
export * from "./CarouselIndu.vue?vue&type=script&lang=js"

import "./CarouselIndu.vue?vue&type=style&index=0&id=729b7761&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-729b7761"]])

export default __exports__